import { render, staticRenderFns } from "./CollegePurchaseStudent.vue?vue&type=template&id=1fd9928f"
import script from "./CollegePurchaseStudent.vue?vue&type=script&lang=js"
export * from "./CollegePurchaseStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports